import styled from '@emotion/styled'

export const Container = styled.div`
  height: 100%;

  .checkpointToolTipText {
    fill: #fff;
    font-size: 20px;
    font-weight: 700;
  }

  .checkpointToolTipBox {
    fill: #1b253f;
  }

  #device-shape-gradient {
    --color-bot: #3379c7;
    --color-stop: #6096f5;
  }

  .connections-group.editOn,
  .alarm-group.editOn,
  .door-group.editOn,
  .camera-group.editOn {
    cursor: grab;
  }

  .camera.editOn .cameraView {
    stroke-width: 4px;
    filter: drop-shadow(0px 0px 10px #3c7ed0);
  }

  .cameraControl.editOn .cameraView {
    stroke-width: 4px;
    filter: drop-shadow(0px 0px 10px #3c7ed0);
  }

  .cameraCircle {
    fill: url(#device-shape-gradient) #3379c7;
    stroke-width: 2px;
    stroke: #fff;
  }

  .cameraView {
    fill: #91b3e670;
    stroke: #3c7ed0;
    stroke-width: 2px;
  }

  .floorDeviceHandle {
    fill: #fff;
    stroke: #566374;
    stroke-width: 2px;
  }

  .hasIncidents .cameraCircle {
    fill: #cf1030;
    filter: drop-shadow(0px 0px 10px #cf1030);
  }

  .dragged .cameraCircle {
    filter: drop-shadow(0px 0px 10px green);
  }

  .invalidPosition .cameraCircle {
    filter: drop-shadow(0px 0px 10px #cf1030);
  }

  .isHighlighted {
    filter: drop-shadow(0px 0px 10px #2e6cdb) drop-shadow(0px 0px 30px #2e6cdb);
  }

  .incidentCountCircle,
  .incidentIconCircle {
    fill: #fff;
  }

  .deviceIncidentLabel {
    fill: #cf1030;
    font-weight: 700;
    user-select: none;
  }

  .incidentIcon {
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2;
    stroke: #cf1030;
    fill: white;
  }

  .connection .connectionLine {
    stroke: #3c7ed0;
    stroke-width: 4px;
    stroke-dasharray: 4;
  }

  .connection.isConnected .connectionLine {
    stroke: #d2c866;
  }

  .connection.tailgateEnabled .connectionLine {
    stroke: #238544;
  }

  .connectionCircle {
    fill: url(#device-shape-gradient) #3379c7;
    stroke-width: 2px;
    stroke: #fff;
  }

  .connection.isConnected .connectionCircle {
    fill: #d2c866;
  }
  .connection.tailgateEnabled .connectionCircle {
    fill: #54d466;
  }

  .removeIconSvg,
  .editIconSvg,
  .checkpointIconSvg {
    cursor: pointer;
  }

  .checkpointToolTipL {
    fill: #fff;
    font-size: 18px;
    font-weight: 700;
  }

  .checkpointToolTipR {
    fill: #fff;
    font-size: 18px;
    font-weight: 700;
  }

  .checkpointCircleToolTipL {
    fill: #1b253f;
  }

  .checkpointCircleToolTipR {
    fill: #1b253f;
  }

  svg {
    overflow: visible;
  }
`
